import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PendoMultiselect from '../../components/multiselect/pendo-multiselect.vue.js';
import PendoGroupOption from '../../components/multiselect/option-types/pendo-group-option.vue.js';
import PendoGuideStatusOption from '../../components/multiselect/option-types/pendo-guide-status-option.vue.js';

var script = {
  name: 'ResourceSelect',
  components: {
    PendoMultiselect,
    PendoGuideStatusOption,
    PendoGroupOption
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    field: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: 'Select Option'
    }
  },
  computed: {
    noResourcesFoundText() {
      const resourcesLabel = {
        page: 'pages',
        feature: 'features',
        trackType: 'track events',
        guide: 'guides',
        poll: 'polls'
      }[this.column.type];
      return `No ${resourcesLabel} found.`;
    }
  },
  methods: {
    onOptionSelect(option) {
      const selectedOption = {
        [this.field]: option[this.field]
      };
      if (this.field === 'guideId') {
        selectedOption.guideStepId = option.guideStepId;
      }
      this.$emit('select', _objectSpread2(_objectSpread2({}, this.column), selectedOption));
    }
  }
};

export { script as default };
//# sourceMappingURL=resource-selector.vue2.js.map
